module.exports = __webpack_public_path__ + "static/media/addiction_treatment.019b37f7.svg";